
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"y":"4","width":"32","height":"4","rx":"2","fill":"currentColor"}}),_c('rect',{attrs:{"y":"24","width":"32","height":"4","rx":"2","fill":"currentColor"}}),_c('rect',{attrs:{"y":"14","width":"32","height":"4","rx":"2","fill":"currentColor"}})])
          )
        }
      }
    